import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import i18n from "./i18n";

import reportWebVitals from './reportWebVitals';

import { BrowserRouter as Router, HashRouter } from 'react-router-dom';

import { I18nextProvider } from "react-i18next";

import { Provider } from 'react-redux';

import { store } from "./store"


// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// import 'jquery/dist/jquery.min.js'
// import 'bootstrap/dist/js/bootstrap.min.js'

ReactDOM.render(
	<Router>
		<Provider store={store}>
			<I18nextProvider i18n={i18n}>
				<App />
			</I18nextProvider>
		</Provider>
	</Router>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
